import axios from '@/api/axios'


const getRelativesList = (data) => {
    return axios
        .post('/admin/relatives/relatives-list', {relatives: data})
        .then(response => response.data)
}

const getRelativesTypesList = (data) => {
    return axios
        .post('/admin/relatives/relatives-types-list', {relatives: data})
        .then(response => response.data)
}

const relativesAdd = (data) => {
    return axios
        .post('/admin/relatives/relatives-add', {relatives: data})
        .then(response => response.data)
}

const relativesEdit = (data) => {
    return axios
        .post('/admin/relatives/relatives-edit', {relatives: data})
        .then(response => response.data)
}

const relativesRemove = (data) => {
    return axios
        .post('/admin/relatives/relatives-remove', {relatives: data})
        .then(response => response.data)
}

export default {
    getRelativesList,
    getRelativesTypesList,
    relativesAdd,
    relativesEdit,
    relativesRemove
}
